import React, { Fragment } from "react";
import dayjs from "dayjs";
import {  useSelector } from "react-redux";
import {  Divider, styled, Typography } from "@mui/material";

const StyledHeadLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 14,
});

const StyledPaper = styled("div")({
  border: "none",
  display: "flex",
  alignItems: "flex-start",
  marginBottom: 16,
});

const StyledDivider = styled(Divider)({
  marginTop: 0,
  marginBottom: 16,
  borderWidth: "0px 0px thin",
  borderColor: "#919eab52",
  borderStyle: "dashed",
  width: "100%",
});

const StyledWrapHead = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

const ExpertiseTab = () => {
  const { result: employeeProfile } = useSelector(
    (state) => state.employeeProfile
  );
  return (
    <div>
      <StyledWrapHead>
        <StyledHeadLabel style={{ marginBottom: 16 }}>
          {`ประวัติการศึกษา`}
        </StyledHeadLabel>
        {/* <ButtonBlue size="small" startIcon={<AddIcon />}>
          เพิ่มวุฒิการศึกษา
        </ButtonBlue> */}
      </StyledWrapHead>

      {employeeProfile && employeeProfile.educations.length > 0 ? (
        employeeProfile.educations.map((education) => (
          <Fragment>
            <StyledPaper>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                }}
              >
                <Typography
                  variant="h6"
                  style={{ width: "calc(100% - 143px)" }}
                >
                  {`(${
                    education.fromYear
                      ? dayjs(`01-01-${education.fromYear}`).format("BBBB")
                      : "-"
                  } ถึง ${
                    education.endYear
                      ? dayjs(`01-01-${education.endYear}`).format("BBBB")
                      : "ไม่ระบุ"
                  }) ${
                    education.university
                      ? education.university
                      : "ไม่ระบุสถานศึกษา"
                  }`}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {`สาขา ${
                    education.major ? education.major : "ไม่ระบุ"
                  }, คณะ ${
                    education.faculty ? education.faculty : "ไม่ระบุ"
                  }, ระดับ ${education.degree}`}
                </Typography>
                <Typography style={{ fontWeight: 700, marginTop: 8 }}>
                  {`เกรดเฉลี่ย: ${education.gpa ? education.gpa : "ไม่ระบุ"}`}
                </Typography>
              </div>
            </StyledPaper>
            <StyledDivider />
          </Fragment>
        ))
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" style={{ color: "grey" }}>
            ไม่มีข้อมูลประวัติการศึกษา
          </Typography>
        </div>
      )}
    </div>
  );
};

export default ExpertiseTab;
